import { useEffect } from 'react'
import { useUserActivity } from '@plug-core/state'

export const IdleTimer = () => {
  const { registerUserActivity } = useUserActivity()

  useEffect(() => {
    window.addEventListener('mousemove', registerUserActivity)
    window.addEventListener('keydown', registerUserActivity)

    return () => {
      window.removeEventListener('mousemove', registerUserActivity)
      window.removeEventListener('keydown', registerUserActivity)
    }
  }, [registerUserActivity])
  return null
}
